import { endOfDay, format, isAfter, isValid, parse } from 'date-fns'

function isAfterDay (date, afterDate) {
  return isAfter(date, endOfDay(afterDate))
}

export function dateStringValidator (v, allowFuture) {
  if (!v) return false
  if (v.length !== 8) return false

  const date = parseDateString(v)

  if (!isValid(date)) return false

  if (isAfterDay(date, new Date()) && !allowFuture) return false

  return true
}

export function parseDateString (s) {
  return parse(s, 'ddMMyyyy', new Date())
}

export function toIsoDateString (d) {
  return format(d, 'yyyy-MM-dd')
}

export function toFriendlyDateString (d) {
  return format(d, 'dd-MM-yyyy')
}
